import type { Platform } from "./Platform";

let installedPlatform: Platform | null = null;

export const platformRef: { current: Platform } = {
    get current(): Platform {
        if (!installedPlatform) {
            throw new Error("Platform is not installed");
        }
        return installedPlatform;
    },
    set current(platform: Platform) {
        installedPlatform = platform;
    },
};

export function getPlatform(): Platform {
    return platformRef.current;
}
